import { Link } from "react-router-dom";
import { useContext } from "react";
import FilterContexts from "../../Variables/FilterContexts";
import { DeletePatient } from "../CRUDPage/FetchData";

const formlist = {patient_data:"patient_data", adddrugrecord:"adddrugrecord", addrecord:"addrecord", list_record:"list_record", list_drug_record: "list_drug_record", test_chart:"test_chart"};
const emptyInfo = {"patient_id": null, "citizen_id": null, "name": null, "gender": null, "birthday": null, "disease": null, "other": null, "phone": null};


function DisplayData({InfoList, InfoText, InfoContent, handleDialogOpen, WhichPage}) {
    const {updateFunc} = useContext(FilterContexts);

    const handleOpen = (target, patientData) => {
        let final_target = target.value ? target.value : target;
        handleDialogOpen(final_target, (final_target in formlist), patientData);
        if(target.value){
            target.value = "";
        }
    }

    return (
        <div className=" flex justify-center overflow-auto text-xl">
            <div>
                {WhichPage==='basic_info' ? 
                    (<button className="px-10 py-2  bg-[#0000] text-[#2a78a5] text-xl font-bold" style={{borderRadius:".5em"}} onClick={(event) => handleOpen("patient_data", emptyInfo)}>新增基本資料+</button>) 
                    : ("")
                }
                <table id="patientData">
                    <thead>
                        <tr className="bg-[#bfbfbf]">
                            <td className="rounded-l-lg pl-2">{" "}</td>
                            {WhichPage==='basic_info' ? 
                                (<tr className="w-1"></tr>) 
                                : ("")
                            }
                            {InfoList.map((item) => (
                                item==="iop_records" ? 
                                (<><th className="">{"測驗時間"}</th><th>{"IOP_OD"}</th><th>{"IOP_OS"}</th></>)
                                : (<th className="p-4" key={"head_"+item}>{InfoText.hasOwnProperty(item) ? (InfoText[item]) : item}</th>)
                            ))}
                            <td colSpan={2} className="rounded-r-lg font-bold text-center pr-4">詳細資料</td>
                        </tr>
                    </thead>
                    <tbody>
                        {InfoContent.map((info, index) => (
                            <tr key={index+1}>
                                <td className="w-2"></td>
                                {WhichPage==='basic_info' ?
                                    (<td className="">
                                        <button className="px-3 bg-[#0000] text-[#2a78a5] text-2xl font-bold" style={{borderRadius:".5em"}} onClick={(event) => handleOpen("patient_data", info)}>+</button>
                                        <button className="px-3 bg-[#0000] text-[#2a78a5] text-4xl" style={{borderRadius:".5em"}} onClick={(event) => DeletePatient(info.record_id)}>-</button>
                                    </td>)
                                    : (<></>)
                                }

                                {InfoList.map((elements) => (
                                    <td className="p-4" key={index+"_"+elements}>{info[elements]}</td>
                                ))}
                                
                                {WhichPage==='basic_info' ?
                                    (
                                    <td key={"buttons"+index}>
                                        <Link to={"../test_record"}><button className="p-1" onClick={() => updateFunc('patientId', info.patient_id)}>詳細資料</button></Link>
                                    </td>
                                    ) : 
                                    (
                                        <td>
                                            {WhichPage==='add_record' ? 
                                                (
                                                    <select className="m-1 p-1 text-center bg-[#ffd500] rounded-lg" onChange={(event) => handleOpen(event.target, {patient_id: info.patient_id, name:info.name, client_data_record_id: info.record_id})}>
                                                        <option value="">編輯</option>
                                                        <option value="adddrugrecord">用藥紀錄</option>
                                                        <option value="addrecord">檢查紀錄</option>
                                                    </select>
                                                ) :
                                                (
                                                <select className="m-1 p-1 text-center bg-[#ffd500] rounded-lg" onChange={(event) => handleOpen(event.target, {patient_id: info.patient_id, name:info.name, client_data_record_id: info.record_id})}>
                                                    <option value="">檢視</option>
                                                    <option value="test_chart">{"趨勢圖"}</option>
                                                    <option value="list_record">{"檢查紀錄"}</option>
                                                    <option value="list_drug_record">{"用藥清單"}</option>
                                                </select>
                                                )
                                            }
                                        </td>
                                    )
                                }
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default DisplayData;